<template>
	<VBtn
		:aria-controls="controls"
		:aria-selected="selected"
		class="structure-btn"
		:color="btnColor"
		elevation="0"
		:ripple="false"
		role="tab"
		:style="style"
		:tabindex="tabindex"
		v-on="$listeners"
	>
		<slot />
	</VBtn>
</template>

<script setup lang="ts">
	import { IndexedObject } from '../../types';
	import { computed } from 'vue';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		controls: {
			type: String,
			required: true,
		},
		selected: {
			type: Boolean,
			default: false,
		},
		tabindex: {
			type: Number,
			required: true,
		},
	});

	const textColor = computed<string>(() => (props.selected ? 'ap-white' : 'ap-grey darken-1'));
	const btnColor = computed<string>(() => (props.selected ? 'ap-blue darken-2' : 'ap-grey lighten-3'));
	const style = computed<IndexedObject>(() => ({ color: convertToHex(textColor.value) }));
</script>

<style lang="scss" scoped>
.v-btn {
	letter-spacing: unset;

	&.v-btn--active::before,
	&:focus::before,
	&:hover::before {
		content: unset !important;
		opacity: 0 !important;
	}

	&:focus {
		outline: 1px dotted $ap-grey-darken1;
	}
}
</style>
